import {
  isJ1QLTreeData,
  isJ1QLListData,
  J1QLListData,
  J1QLTreeData,
  J1QLResultData,
} from '../../../types/J1QL';

export default <T extends J1QLResultData>(
  previousData: T | undefined,
  newData: T | undefined
) => {
  if (!newData) {
    return undefined;
  } else if (!previousData) {
    return newData;
  } else {
    // Take all of the results from the new query response, but keep the old
    // data (so we can carefully merge it below)
    const newResult: T = {
      ...previousData,
      cursor: newData.cursor,
      type: newData.type,
      totalCount: newData.totalCount,
    };

    // Merge the data based on the type of data result we are expecting
    if (isJ1QLTreeData(newData)) {
      const newEdges = ((newResult as J1QLTreeData).data?.edges || []).concat(
        newData.data!.edges
      );
      const newVertices = (
        (newResult as J1QLTreeData).data?.vertices || []
      ).concat(newData.data!.vertices);

      newResult.data = { edges: newEdges, vertices: newVertices };
    } else if (isJ1QLListData(newData)) {
      newResult.data = ((newResult as J1QLListData).data || []).concat(
        newData.data || []
      );
    } else {
      return undefined;
    }

    return newResult;
  }
};
